import DTRefundAndCancelSelectedItemsNode from '../NodeGroups/DTSelectedItemTransaction/Nodes/DTRefundAndCancelSelectedItemsNode/DTRefundAndCancelSelectedItemsNode';
import { getShowConfirmationPage } from '../../../selectors/tools';
import { useSelector } from 'react-redux';

const CancelAndRefundSelectedItemsThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return (
    <DTRefundAndCancelSelectedItemsNode
      showConfirmation={showConfirmationPage}
      message={'The items have been canceled and the refund has been processed.'}
    />
  );
};

export default CancelAndRefundSelectedItemsThenSendMacro;
